const tree = {
  channels:[
    {
      value: 'base',
      name: 'Base',
      description: {
        title: "Base",
        detail: "Use esse canal para talentos prospectados a partir de listas no Backoffice ou no Metabase, seja para abordagem por mailing, Linkedin ou WhatsApp."
      },
      sources: [
        {
          value: 'whatsapp',
          mediums: [
            {
              value: 'mensagem',
            },
            {
              value: 'email',
            }
          ]
        }, {
          value: 'linkedin',
          mediums: [
            {
              value: 'mensagem',
            }
          ]
        },
        {
          value: 'mailing',
          mediums: [
            {
              value: 'mensagem',
            },
            {
              value: 'email',
            }
          ]
        }
      ]
    },
    {
      value: 'crm',
      name: 'CRM',
      description: {
        title: "CRM",
        detail: "Use esse canal para prospectar talentos que estão na base de CRM (Dream Job)."
      } ,
      sources: [
        {
          value: 'linkedin',
          mediums: []
        },
        {
          value: 'mailing',
          mediums: []
        },
        {
          value: 'whatsapp',
          mediums: []
        },
      ]
    },
    {
      value: 'comunidades',
      name: 'Comunidades',
      description: {
        title: "Comunidades",
        detail: "Use esse canal para fazer publicações em grupos nas redes sociais, seja uma comunidade de React do Facebook ou um grupo de Ciência de Dados no Telegram."
      } ,
      sources: [
        {
          value: 'whatsapp',
          mediums: [
            {
              value: "Kotlin-Android",
            },
            {
              value: "TecnologiaAndroid",
            },
            {
              value: "ANDROID",
            },
            {
              value: "Android-Dev",
            },
            {
              value: "Desenvolvedores-Java",
            },
            {
              value: "Java-Framework",
            },
            {
              value: "Java-Dev",
            },
            {
              value: "Java-Brasil",
            },
            {
              value: "Java-Web-Dev",
            },
            {
              value: "Hibernate",
            },
            {
              value: "Spring",
            },
            {
              value: "Kotlin-Dev-Wpp",
            },
            {
              value: "UX/UI-DESIGNERS-BRASIL-🇧🇷",
            },
            {
              value: "Product-Owner-3",
            },
            {
              value: "Product-Owner-2",
            },
            {
              value: "Product-Owner-1",
            },
            {
              value: "Amigos-Node.JS",
            },
            {
              value: "React-JS-|-React-Native",
            },
            {
              value: "Vagas-INFO-sec4",
            },
            {
              value: "Vagas-INFO-sec5",
            },
            {
              value: "Vagas-INFO-sec6",
            },
            {
              value: "Vagas-de-Emprego-Salvador-Bahia---1",
            },
            {
              value: "Vagas-de-Emprego-Salvador-Bahia---2",
            },
            {
              value: "Afro-Data",
            },
          ]
        },
        {
          value: 'telegram',
          mediums: [
            {
              value: "Kotlin-em-Portugues",
            },
            {
              value: "Elixir-BR",
            },
            {
              value: "NodeBR",
            },
            {
              value: "Node.Js-Brasil",
            },
            {
              value: "Node.Js-Rio",
            },
            {
              value: "dockerbr",
            },
            {
              value: "Docker-POA",
            },
            {
              value: "API-Builders-BR",
            },
            {
              value: "AWS-Brasil",
            },
            {
              value: "Spring-Brasil",
            },
            {
              value: "JavaScript-Brasil",
            },
            {
              value: "JavaScript-Brasil-Oficial",
            },
            {
              value: "Grupy-SP",
            },
            {
              value: "PyCoding",
            },
            {
              value: "PHP-Brasil-Vagas",
            },
            {
              value: "Laravel-Brasil",
            },
            {
              value: "PyKivy-pt-BR",
            },
            {
              value: "Python-Brasil",
            },
            {
              value: "Python-Floripa",
            },
            {
              value: "Python-Rio",
            },
            {
              value: "Python-em-Sergipe",
            },
            {
              value: "Frevo-On-Rails",
            },
            {
              value: "Ruby-On-Rails-CE",
            },
            {
              value: "Ruby-On-Rails-GO",
            },
            {
              value: "Ruby-On-Rails-PI",
            },
            {
              value: "Ruby-On-Rails-SP",
            },
            {
              value: "Ruby-On-Rails-DF",
            },
            {
              value: "Ruby-On-Rails-RJ",
            },
            {
              value: "Ruby-On-Rails-PB",
            },
            {
              value: "Ruby-On-Rails-Brasil",
            },
            {
              value: "NoSQL-Brasil",
            },
            {
              value: "MySQL-BR",
            },
            {
              value: "SQL-Server-DBA",
            },
            {
              value: "SQLCLR-Maniacs",
            },
            {
              value: "Jenkins-Chapter-Brasil",
            },
            {
              value: "MongoDB-Mongoose-Brasil",
            },
            {
              value: "Google-Cloud-Platform-Brasil",
            },
            {
              value: "DBA-BRASIL",
            },
            {
              value: "Kubuntu-Brasil",
            },
            {
              value: "Ubuntu-Brasil-Oficial",
            },
            {
              value: "Ubuntu-Linux-Brasil",
            },
            {
              value: "Back-end-Brasil",
            },
            {
              value: "Front-end-BR",
            },
            {
              value: "Fullstack-developers-Brasil",
            },
            {
              value: "Devops-BR",
            },
            {
              value: "ChurrOps-on-Jobs",
            },
            {
              value: "Brasil-Linux",
            },
            {
              value: "JobsDevops",
            },
            {
              value: "BR-LINUX",
            },
            {
              value: "Android-Studio-Brasil",
            },
            {
              value: "Big-Data-BR",
            },
            {
              value: "Pt-BR-Data-Science-&-Python",
            },
            {
              value: "Vagas-UX/UI",
            },
            {
              value: "#Security---Sinergia-Soluções",
            },
            {
              value: "Undeadsec",
            },
            {
              value: "Análise-Forense-Brasil",
            },
            {
              value: "Ground-Zero-Security",
            },
            {
              value: "Darknet-BR",
            },
            {
              value: "DarkInside",
            },
            {
              value: "Forense-e-Cia",
            },
            {
              value: "Vagas-SegInfo",
            },
            {
              value: "Papo-de-dev",
            },
            {
              value: "Linguagens-de-Programação",
            },
            {
              value: "Gitlab-BR",
            },
            {
              value: "Developers",
            },
            {
              value: "JN-Vagas-TI-+-RH",
            },
            {
              value: "Vagas-de-TI",
            },
            {
              value: "Excelência-Projetos",
            },
            {
              value: "IT-Jobs-Brasil",
            },
            {
              value: "GitHub-Brasil",
            },
            {
              value: "Clube-de-Vagas-de-TI",
            },
            {
              value: "Vagas-TIC-BR",
            },
            {
              value: "Vagas-T.I.",
            },
            {
              value: "developersRJ-(postar-somente-com-faixa-salaria)",
            },
            {
              value: "Vagas-TI-DF",
            },
            {
              value: "TI-Vagas-SP",
            },
          ]
        },
        {
          value: 'github',
          mediums: [
            {
              value: "Backend-Brasil",
            },
            {
              value: "Front-end-Brasil",
            },
            {
              value: "CocoaHeadsBrasil--iOS-",
            },
            {
              value: "Android-Dev-BR",
            },
            {
              value: "UX-Brasil",
            },
            {
              value: "QA-Brasil",
            },
            {
              value: "Sou-Java",
            },
            {
              value: "Dot-Net-Dev-BR",
            },
            {
              value: "React-Native-Drops",
            },
            {
              value: "React-Brasil",
            },
            {
              value: "Flutter-BR",
            },
            {
              value: "Flutterando",
            },
            {
              value: "PHP-Dev-BR",
            },
            {
              value: "Gommunity",
            },
            {
              value: "VueJS-BR",
            },
            {
              value: "Rust-Dev-BR",
            },
            {
              value: "Elm-Jobs",
            },
            {
              value: "DevOps-BR",
            },
            {
              value: "Developers-RJ",
            },
            {
              value: "DevSSA",
            },
            {
              value: "DevFSA",
            },
            {
              value: "Cangaceiros-Devels",
            },
            {
              value: "Minas-de-TI",
            },
            {
              value: "Django-Girls",
            },
            {
              value: "PyLadies",
            },
          ]
        },
        {
          value: 'facebook',
          mediums: [
            {
              value: "Kotlin-Brasil",
            },
            {
              value: "Android-Studio-Brasil",
            },
            {
              value: "AndroidDev",
            },
            {
              value: "Grupo-de-Programadores-Android,-iOS-e-Windows-Mobile",
            },
            {
              value: "Desenvolvedores-Android",
            },
            {
              value: "Desenvolvedores-IOS-e-Android",
            },
            {
              value: "Desenvolvedores-Mobile",
            },
            {
              value: "Desenvolvedores-Mobile-Brasil",
            },
            {
              value: "Vagas-Mobile-Dev",
            },
            {
              value: "AWS-DevOps-BR",
            },
            {
              value: "Java-Aberto",
            },
            {
              value: "BackEnd-Brasil-Facebook",
            },
            {
              value: "Java-Brasil-roxo",
            },
            {
              value: "Java-Brasil-preto",
            },
            {
              value: "Java-Brasil-Facebook",
            },
            {
              value: "JavaBrasil",
            },
            {
              value: "EMPREGOS:-JAVA",
            },
            {
              value: "Vaga-TI-mundorede",
            },
            {
              value: "vagas-de-ti-Facebook",
            },
            {
              value: "Vagas-de-TI-em-São-Paulo",
            },
            {
              value: "Vagas-em-TI",
            },
            {
              value: "TI-Analista-de-Sistema-Desenvolvedores-funcionais-Vagas-de-Emprego",
            },
            {
              value: "Vagas-Programadores/Desenvolvedores",
            },
            {
              value: "Vagas-TI-chaplin",
            },
            {
              value: "Vagas-TI-&-Telecom-Brasil",
            },
            {
              value: "Empregos-TI-Especialistas",
            },
            {
              value: "Cloud-Computing-Brasil",
            },
            {
              value: "DevOps-na-Prática",
            },
            {
              value: "Vagas-Back-End-&-Fullstack-5k+",
            },
            {
              value: "DevOps-BR",
            },
            {
              value: "Hipster-Ponto-Tech",
            },
            {
              value: "Vagas-de-Emprego-LGBTQ+",
            },
            {
              value: "Grupo-LGBTQ",
            },
            {
              value: "ReinoLGBTQ+",
            },
            {
              value: "LDRV-Manda-Jobs",
            },
            {
              value: "WoMakersCode",
            },
            {
              value: "PHP-Women-BR",
            },
            {
              value: "PrograMaria",
            },
            {
              value: "Devs-JavaGirl",
            },
            {
              value: "Women-Up-VAGAS",
            },
            {
              value: "Mulheres-Desenvolvedoras",
            },
            {
              value: "DME-Mulheres-Empreendedoras",
            },
            {
              value: "Empreendoras",
            },
            {
              value: "Mulher-que-Empreende",
            },
            {
              value: "Mulheres,-Sim!-Empreendedoras,-Sempre!",
            },
            {
              value: "Mulheres-Empreendedoras-BR",
            },
            {
              value: "MULHERES-EMPREENDEDORAS",
            },
            {
              value: "Trabalho-em-rede:-mulheres-nas-artes",
            },
            {
              value: "Mulheres-do-Audiovisual",
            },
            {
              value: "Economia-das-Minas",
            },
            {
              value: "Feministrampos",
            },
            {
              value: "Entre-Elas",
            },
            {
              value: "Mulheres-Unidades-pela-Democracia",
            },
            {
              value: "Mulheres-Pela-Democracia!",
            },
            {
              value: "League-of-Divas",
            },
            {
              value: "MULHERES-PELA-DEMOCRACIA",
            },
            {
              value: "Elas-por-elas-LGBTQ+",
            },
            {
              value: "Elixir-BR",
            },
            {
              value: "Elixir-Lang-BR",
            },
            {
              value: "Vagas-de-Deficientes-para-Surdos-e-Deficientes-Auditivos",
            },
            {
              value: "PCD-Empregos",
            },
            {
              value: "PCD-Vagas-de-Emprego",
            },
            {
              value: "Vagas-para-PCD-Brasil",
            },
            {
              value: "Elixir-Brasil",
            },
            {
              value: "Vagas-para-PCD",
            },
            {
              value: "Emprego-para-PCD",
            },
            {
              value: "Empregos-para-PcD",
            },
            {
              value: "Vagas-para-Pessoas-com-Deficiência",
            },
            {
              value: "PCDs-Online-Brasil",
            },
            {
              value: "PCDs-Pessoas-Com-Deficiência",
            },
            {
              value: "Pessoa-com-Deficiência",
            },
            {
              value: "Emprego-para-PCD-no-Brasil",
            },
            {
              value: "Empregos-para-PCD---Vagas",
            },
            {
              value: "Vagas-de-Emprego-para-pessoa-com-deficiência",
            },
            {
              value: "Banco-de-Talentos---Pessoas-com-Deficiência",
            },
            {
              value: "Empregos-Pdc---Dicas-e-Dica-empregos",
            },
            {
              value: "Rede-de-Profissionais-Negros",
            },
            {
              value: "EmpregueAfro",
            },
            {
              value: "Pretos-e-Pretas-Raíz",
            },
            {
              value: "Intelectualidade-Afro-Brasileira",
            },
            {
              value: "Publicitários-Negros",
            },
            {
              value: "Designers-Negros",
            },
            {
              value: "Ruby-on-Rails-Brasil",
            },
          ]
        },
        {
          value: 'linkedin',
          mediums: [
            {
              value: "Python-Brasil-só-para-mulheres",
            },
            {
              value: "Mulheres-na-tecnologia",
            },
            {
              value: "Mulheres-na-tecnologia-MNT",
            },
            {
              value: "WoMakersCode",
            },
            {
              value: "Vagas-de-TI-para-Mulheres",
            },
            {
              value: "Mulheres-de-TI",
            },
            {
              value: "Mulheres-na-TI",
            },
            {
              value: "Mulheres-no-Marketing-Digital",
            },
            {
              value: "Mulheres-na-Tecnologia",
            },
            {
              value: "Grupo-de-mulheres-IT-Brasil",
            },
            {
              value: "Mulheres-na-Liderança",
            },
            {
              value: "Rede-Brasileira-de-Mulheres-LBTQ+",
            },
            {
              value: "Mulheres-Levantam-Mulheres---MLM",
            },
            {
              value: "MULHERES-DE-NEGÓCIOS-MDN",
            },
            {
              value: "Mulheres-no-E-commerce",
            },
            {
              value: "MADI-Mulheres-atuando-em-Design-Inovação",
            },
            {
              value: "Mulheres-em-Inovação",
            },
            {
              value: "Android-Brasil",
            },
            {
              value: "Android-Developrs-Brasil",
            },
            {
              value: "iOS-Developer-Brasil",
            },
            {
              value: "iOS-Developers-Brazil",
            },
            {
              value: "DevOps-Brasil",
            },
            {
              value: "Desenvolvedores-Java",
            },
            {
              value: "Desenvolvedores-Java-Brasil",
            },
            {
              value: "Java-BR",
            },
            {
              value: "Java-Brasil-Linkedin",
            },
            {
              value: "Kotlin-Brasil-Linkedin",
            },
            {
              value: "Kotlin-Developrs-Brasil",
            },
            {
              value: "React-Brasil",
            },
            {
              value: "Kubernetes-Brasil",
            },
            {
              value: "Vagas-SAP",
            },
            {
              value: "Vagas-de-TI",
            },
            {
              value: "VAGAS-DE-TI",
            },
            {
              value: "Vagas-de-TI-em-SP",
            },
            {
              value: "TI-Vagas",
            },
            {
              value: "Vagas-TI",
            },
            {
              value: "Network-e-Vagas",
            },
            {
              value: "Dev-Brasil",
            },
            {
              value: "AfrodIn",
            },
            {
              value: "Ruby-On-Rails-Brasil-Linkedin",
            },
            {
              value: "Girls-In-Tech-Brasil",
            },
            {
              value: "MaisMulheresnati",
            },
          ]
        },
        {
          value: 'meetups',
          mediums: [
            {
              value: "Ministry-of-Testing-São-Paulo",
            },
            {
              value: "Elixir-User-SP",
            },
          ]
        },
        {
          value: 'slack',
          mediums: [
            {
              value: "AndroidDevBr",
            },
            {
              value: "BACKEND-BR",
            },
            {
              value: "Front-End-Brasil",
            },
            {
              value: "iOS-DevBR",
            },
            {
              value: "Data-Science",
            },
            {
              value: "Data-Hacker",
            },
            {
              value: "Frontend-Brasil",
            },
            {
              value: "UX/UI-DESIGNERS-BRASIL",
            },
            {
              value: "Product-Management-Brasil",
            },
            {
              value: "JavaDevBr",
            },
            {
              value: "NodeBR",
            },
            {
              value: "Brazil-JS",
            },
            {
              value: "React-Brasil",
            },
            {
              value: "grupy-sanca",
            },
            {
              value: "opensanca",
            },
            {
              value: "Vários-workplaces",
            },
            {
              value: "Mulheres-de-Produto",
            },
            {
              value: "Ruby-On-Rails-SC",
            },
          ]
        },
        {
          value: 'google groups',
          mediums: [
            {
              value: "Desenvolvimento_Java"
            },
            {
              value: "PyLadies"
            },
            {
              value: "Python"
            },
            {
              value: "Python_Brasil"
            }
          ]
        },
        {
          value: 'discord',
          mediums: [
            {
              value: "InfoSec-BR",
            },
            {
              value: "rocketseat",
            },
          ]
        },
        {
          value: 'remotar',
          mediums: []
        }
      ]
    },
    {
      value: 'growth',
      name: 'Growth',
      description: {
        title: "Growth",
        detail: "Use esse canal em campanhas de mailing e promoções pagas. Esse canal é usado apenas pelo time de Performance."
      } ,
      sources: [
        {
          value: 'comunidades',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'empregos',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'facebook',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'instagram',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'linkedin',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'linkedinads',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'linkjobs',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'rede_indica',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'mailing',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'newsletter',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'telegram',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        },
        {
          value: 'google',
          mediums: [
            {
              value: "indicaintera",
            },
            {
              value: "vaga",
            },
            {
              value: "woohp",
            },
            {
              value: "woohp2",
            },
            {
              value: "updates",
            },
            {
              value: "50backend",
            },
            {
              value: "30data",
            },
            {
              value: "campo aberto",
            },
          ]
        }
      ]
    },
    {
      value: "inbound",
      name: 'Inbound',
      description: {
        title: "Inbound",
        detail: "Use esse canal para fazer publicações no feed do LinkedIn."
      } ,
      sources: [
        {
          value: "linkedin",
          mediums: [
            {
              value: "feed",
            }
          ]
        }
      ]
    },
    {
      value: "indicacao",
      name: 'Indicação',
      description: {
        title: "Indicação",
        detail: "Use esse canal para a prospecção de talentos a partir de uma lista que o cliente gera. Alguns perfis de referência que os clientes enviam não foram abordados por eles. Nesse caso, use esse canal"
      } ,
      sources: [
        {
          value: "linkedin",
          mediums: []
        },
        {
          value: "telegram",
          mediums: []
        },
        {
          value: "whatsapp",
          mediums: []
        }
      ]
    },
    {
      value: "organico",
      name: 'Orgânico',
      description: {
        title: "Orgânico",
        detail: "Use esse canal para talentos vindos da página de vagas, geralmente vagas.byintera.com."
      } ,
      sources: [
        {
          value: "home",
          mediums: []
        }
      ]
    },
    {
      value:'prospec_linkedin',
      name: 'Prospecção no LinkedIn',
      description: {
        title: "Prospecção no LinkedIn",
        detail: "Use esse canal para talentos vindos da prospecção ativa no LinkedIn. Geralmente é o canal mais utilizado por Hunters."
      } ,
      sources: [
        { 
          value:'linkedin',
          mediums: [
            {
              value: "handpick",
            },
            {
              value: "linkedin_helper",
            },
            {
              value: "msg",
            },
          ]
        },
        {
          value: 'telegram',
          mediums: [
            {
              value: "handpick",
            },
            {
              value: "linkedin_helper",
            },
            {
              value: "msg",
            },
          ]
        },
        {
          value: 'whatsapp',
          mediums: [
            {
              value: "handpick",
            },
            {
              value: "linkedin_helper",
            },
            {
              value: "msg",
            },
          ]
        }
      ]
    },
    {
      value:'parcerias',
      name: 'Parcerias',
      description: {
        title: "Parcerias",
        detail: "Use esse canal para talentos vindos de campanhas nos canais de parceiros, como uma divulgação em uma universidade ou em um evento de tecnologia."
      } ,
      sources: [
        {
          value:'instituicao',
          mediums: []
        }
      ]
    },
    {
      value: "success",
      name: 'Success',
      description: {
        title: "Success",
        detail: "Use esse canal na reciclagem de leads vindos pelo time de Success."
      } ,
      sources: [
        {
          value: "linkedin",
          mediums: []
        },
        {
          value: "telegram",
          mediums: []
        },
        {
          value: "whatsapp",
          mediums: []
        }
      ]
    },
  ]

}

export const channels = tree.channels;

export default tree;